module.exports = __webpack_public_path__ + "img/Profil_CS-Slimlinerii_Universalclassic.ec962168.jpg";